import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
export default {
  namespaced: true,
  state: {
    // 是否登录
    isLogged: !!YL.cookies.get(process.env.VUE_APP_LOGIN_TOKEN)
  },
  getters: {
    /**
     * @description 返回当前的是否登录
     * @param {Object} state state
     */
    isLogged: function isLogged(state) {
      return state.isLogged;
    }
  },
  mutations: {
    /**
     * @description 设置用户登陆状态
     * @param {Object} state state
     * @param {Boolean} value 是否登录
     */
    isLoggedSet: function isLoggedSet(state, value) {
      state.isLogged = value;
    }
  },
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, commit, dispatch, _ref2, _ref2$account, account, _ref2$password, password, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
                _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$account = _ref2.account, account = _ref2$account === void 0 ? '' : _ref2$account, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
                _context.next = 4;
                return api.account({
                  account: account,
                  password: password
                });

              case 4:
                res = _context.sent;
                // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                // 整个系统依赖这两个数据进行校验和存储
                // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                // token 代表用户当前登录状态 建议在网络请求中携带 token
                // 如有必要 token 需要定时更新，默认保存一天
                util.cookies.set('uuid', res.storeAccountId);
                util.cookies.set(process.env.VUE_APP_LOGIN_TOKEN, res.token);
                commit('isLoggedSet', true); // 设置 vuex 用户信息

                _context.next = 10;
                return dispatch('d2admin/user/set', _objectSpread({
                  name: res.accountName
                }, res), {
                  root: true
                });

              case 10:
                _context.next = 12;
                return dispatch('d2admin/permission/set', res.positionAuthorities, {
                  root: true
                });

              case 12:
                _context.next = 14;
                return dispatch('load');

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$confirm = _ref4.confirm,
          confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove(process.env.VUE_APP_LOGIN_TOKEN);
                  util.cookies.remove('uuid'); // 清空 vuex 用户信息

                  _context2.next = 4;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 4:
                  commit('isLoggedSet', false); // 重置权限并且跳转到登录页

                  commit('d2admin/permission/isLoadedSet', false, {
                    root: true
                  });
                  commit('d2admin/message/isImLogin', false, {
                    root: true
                  });
                  _context2.next = 9;
                  return dispatch('d2admin/permission/load', [], {
                    root: true
                  });

                case 9:
                  // 跳转路由
                  router.replace('/login');
                  router.push({
                    name: 'refresh'
                  });
                  _context2.next = 13;
                  return YL.sleep(0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前用户吗', '退出登录', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          dispatch('d2admin/page/closeAll', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          }); // Message({ message: '取消注销操作' })
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = _ref5.dispatch;
                _context3.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                _context3.next = 5;
                return dispatch('d2admin/permission/load', null, {
                  root: true
                });

              case 5:
                _context3.next = 7;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 7:
                _context3.next = 9;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 9:
                _context3.next = 11;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 11:
                _context3.next = 13;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 13:
                _context3.next = 15;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 15:
                _context3.next = 17;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};